import React from 'react';
import './App.css';
import { useState, useRef, useEffect } from 'react';
import { ethers } from 'ethers';
import logo from './walletConnect.png';
import headerImage from './siteBanner.png'
import image1 from './SiteImage.png'
import image2 from './SiteImage2.png'
import image3 from './SiteImage3.png'
import image4 from './SiteImage4.png'
import mintImage from './Mint.png'
import ogMintImage from './og_mint.png'
import addresses from './addresses'

import contractAbi from './contract_details/contract_abi.json'

const keccak256 = require("keccak256");
const { MerkleTree } = require("merkletreejs");




function App() {


  const [ currentUser, setUser ] = useState(null);
  const [ someOneLoggedIn, setLogin ] = useState(false);
  const [ a_provider, setProvider ] = useState(null);
  const [ ogMintStatus, setOgMintActive] = useState(null);
  const [ publicMintStatus, setPublicMintActive ] = useState(null);
  const [ totalSupply, setTotalSupply ] = useState(null);
  const [ collectionSize, setCollectionSize]  = useState(null);
  const [ loadingPublicMint, setLoadingPublicMint ] = useState(null);
  const [ loadingOgMint, setLoadingOgMint ] = useState(null);
  const [ error, setError ] = useState(null);
  const [ publicMintAmount, setPublicMintAmount] = useState(1);
  const [ list, setList ] = useState(null);

  const contractAddress = "0x5f0EED9a8763BC0F10149CC45D594aA0F1D3e30b";
  const infura_key =   process.env.REACT_APP_INFURA_KEY

  const G_RPC_URL = `https://goerli.infura.io/v3/${infura_key}`
  const mainnet_RPC = `https://mainnet.infura.io/v3/${infura_key}`


  const readContract = new ethers.Contract(
    contractAddress,
    contractAbi, 
    new ethers.providers.JsonRpcProvider(mainnet_RPC)
  )

  const checkActiveMints = async () => {
    try {
      let ogMintActive = await readContract.ogMintActive();
      setOgMintActive(ogMintActive);
      let publicMintActive = await readContract.publicSaleActive();
      setPublicMintActive(publicMintActive);
    } catch (error) {
      console.log(error);
    }
  };

  const checkCollectionSizeAndTotalSupply = async () => {
    try {
      let collection = await readContract.actualCollectionSize();
      setCollectionSize(collection.toString());
      let supply = await readContract.totalSupply();
      setTotalSupply(supply.toString());
    } catch (error) {
      console.log(error);
    }
  };

  const publicMintTransaction = async () => {
    setLoadingPublicMint(true);
    try {
      const signer = a_provider.getSigner();
      const publicSaleTransaction = (publicMintAmount * 0.01)
        .toFixed(3)
        .toString();
      const writeContract = new ethers.Contract(
        contractAddress,
        contractAbi,
        signer
      );
      await writeContract.publicSaleMint(publicMintAmount, {
        value: ethers.utils.parseEther(publicSaleTransaction)._hex,
      });
    } catch (error) {
      if (error) {
        console.log(error);
        setError(error.code);
      }
    }
    setLoadingPublicMint(false);
  };

  const buildList = () => {
    const leaves = addresses.map((address) => keccak256(address));
    const tree = new MerkleTree(leaves, keccak256, { sortPairs: true });
    const rootHash = tree.getHexRoot();
    console.log("building list");
    console.log(rootHash);
    const obj = {};
    for (let i = 0; i < addresses.length; i++) {
      let hashAddressFor = keccak256(addresses[i]);
      let forProof = tree.getHexProof(hashAddressFor);
      obj[addresses[i]] = forProof;
    }
    setList(obj);
  };

  const ogMintTransaction = async () => {
    setLoadingOgMint(true);
    try {
      const signer = a_provider.getSigner();
      const writeContract = new ethers.Contract(
        contractAddress,
        contractAbi,
        signer
      );
      console.log("This is list[currentUser]");
      console.log(list[currentUser]);
      await writeContract.ogMint(1,list[currentUser]);

    } catch (error) {
      if (error) {
        console.log(error);
        setError(error.code);
      }
      setLoadingOgMint(false);
    }
    setLoadingOgMint(false);
  };
  
  const handleIncrementClick = () => {
    if (publicMintAmount >= 0 && publicMintAmount < 10) {
      setPublicMintAmount(publicMintAmount + 1);
    }
  };

  const handleDecrementClick = () => {
    if (publicMintAmount > 0 && publicMintAmount !== 1) {
      setPublicMintAmount(publicMintAmount - 1);
    }
  };

  // initial wallet connect
  // opens metamask and connects wallet to site 
  const connectWallet = async() => {
    try {
      let provider = new ethers.providers.Web3Provider(window.ethereum)
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();
      console.log(signer.getAddress())
      let _address = signer.getAddress();
      setProvider(provider);

    
      // get value from promise (wallet address)
      const address = async() => {
        try {
          console.log("awaiting address")
          const _user = await _address;
          setUser(_user);
          setLogin(true);

        console.log(_user)
        }
        catch (err) {
          console.log(err);
        }
      }

      address();
      console.log("this is current user")

    }

    catch (error) {
      if (error) {
        console.log(error);
      }
    }
  }

  useEffect(() => { 
    //buildList();
  
  }, [currentUser]);

  checkCollectionSizeAndTotalSupply();

  return (
    <div className="App">
      <header className="App-header"> 
    
        <img src={headerImage} alt="Banner" display="flex" width="500px" height ="100px"/>
        {someOneLoggedIn ?<p className="user-align">Current User: {currentUser}</p> : <button className="button" onClick={() => connectWallet()}><img src={logo} className="Pic" alt="Wallet Connect"/>
</button>}
      </header>

      <div>{totalSupply}/500</div>
      {someOneLoggedIn?
      <div className='App-header'>
        <div> {publicMintAmount}</div>
        <button className="button1" onClick={() => handleDecrementClick() }>-</button>
        <button className="button1" onClick={() => handleIncrementClick() }>+</button>

        <button className="button1" onClick={() => publicMintTransaction() }><img src={mintImage} alt="mint" display="flex" width="200px" height ="75px"/></button>
      </div>:null
      }

      <div className='App_feed'>
        <img src={image1} alt="Image1" />
        <img src={image2} alt="Image2"/>
        <img src={image3} alt="Image3" />
        <img src={image4} alt="Image4" />

      </div>

    </div>
  );
}

export default App;




